import { EmoticonSickOutlineIcon } from './EmoticonSickOutlineIcon';

/**
 * author: Google
 * id CBB4F1C3-3479-4F94-9F15-3D844889609A
 * name emoticon-sick-outline
 * version: 5.5.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/emoticon-sick-outline.svg
 * tags
 * - Emoji 
 * - Medical / Hospital 
 */
export const FeverOutlineIcon = EmoticonSickOutlineIcon;
export default FeverOutlineIcon